import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "nxsetup-outer native-auth" }
const _hoisted_2 = {
  key: 0,
  class: "setup-section"
}
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = {
  key: 1,
  class: "setup-section"
}
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = {
  key: 2,
  class: "setup-section"
}
const _hoisted_7 = { id: "folder-list" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XImg = _resolveComponent("XImg")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "setup-step",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          class: "card",
          key: _ctx.step
        }, [
          _createVNode(_component_XImg, {
            class: "banner",
            src: _ctx.banner,
            "svg-tag": true
          }, null, 8, ["src"]),
          (_ctx.step === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'You are now logged in to the server!')) + " ", 1),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t(
              'memories',
              'You can set up automatic uploads from this device using the Nextcloud mobile app. Click the button below to download the app, or skip this step and continue.',
            )) + " ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_NcButton, {
                    variant: "secondary",
                    class: "button button-white",
                    href: "https://play.google.com/store/apps/details?id=com.nextcloud.client"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('memories', 'Set up automatic upload')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_NcButton, {
                    variant: "primary",
                    class: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step++))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('memories', 'Continue')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (_ctx.step === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.t(
              'memories',
              'Memories can show local media on your device alongside the media on your server. This requires access to the media on this device.',
            )) + " ", 1),
                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.hasMediaPermission
              ? _ctx.t('memories', 'Access to media has been granted.')
              : _ctx.t(
                  'memories',
                  'Access to media is not available yet. If the button below does not work, grant the permission through settings.',
                )) + " ", 1),
                  _createElementVNode("div", _hoisted_5, [
                    (!_ctx.hasMediaPermission)
                      ? (_openBlock(), _createBlock(_component_NcButton, {
                          key: 0,
                          variant: "secondary",
                          class: "button button-white",
                          onClick: _ctx.grantMediaPermission
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('memories', 'Grant permissions')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_NcButton, {
                      variant: _ctx.hasMediaPermission ? 'secondary' : 'primary',
                      class: _normalizeClass(["button", { 'button-white': _ctx.hasMediaPermission }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step += _ctx.hasMediaPermission ? 1 : 2))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hasMediaPermission ? _ctx.t('memories', 'Continue') : _ctx.t('memories', 'Skip this step')), 1)
                      ]),
                      _: 1
                    }, 8, ["variant", "class"])
                  ])
                ]))
              : (_ctx.step === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Choose the folders on this device to show on your timeline.')) + " " + _toDisplayString(_ctx.t(
              'memories',
              'If no folders are visible here, you may need to grant the app storage permissions, or wait for the app to index your files.',
            )) + " ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'You can always change this in settings. Note that this does not affect automatic uploading.')) + " ", 1),
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.syncStatus != -1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_ctx.t('memories', 'Synchronizing local files ({n} done).', { n: _ctx.syncStatus })) + " ", 1),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'This may take a while. Do not close this window.')), 1)
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.localFolders, (folder) => {
                            return (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                              key: folder.id,
                              modelValue: folder.enabled,
                              "onUpdate:modelValue": [($event: any) => ((folder.enabled) = $event), _ctx.updateDeviceFolders],
                              type: "switch"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(folder.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                          }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_NcButton, {
                        variant: "secondary",
                        class: "button button-white",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step++))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Finish')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    })
  ]))
}